import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface HealthVital {
  id: string;
  weight: string;
  bp: string;
  cvsPulse: string;
  dateTime: string;
  appointmentId: string | null;
  userId?: string;
  userName?: string;
  appointmentDate?: string;
}

export interface CreateHealthVitalInput {
  userId: string;
  appointmentId?: string;
  weight: string;
  bp: string;
  cvsPulse: string;
}

export const healthVitalsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHealthVitalsByAppointment: builder.query<HealthVital[], string>({
      query: (appointmentId) => `/health-vitals/appointment/${appointmentId}`,
      transformResponse: (res: ApiResponse<{ vitals: HealthVital[] }>) => res.data.vitals,
      providesTags: ["HealthVitals"],
    }),
    createHealthVital: builder.mutation<HealthVital, CreateHealthVitalInput>({
      query: (body) => ({ url: "/health-vitals", method: "POST", body }),
      transformResponse: (res: ApiResponse<HealthVital>) => res.data,
      invalidatesTags: ["HealthVitals"],
    }),
  }),
});

export const { useGetHealthVitalsByAppointmentQuery, useCreateHealthVitalMutation } = healthVitalsApi;
